import { action } from "mobx";
import notificationService from "src/services/NotificationService";

export default class NotificationStore {

  @action
  fetchNotificationByType = async (type, limit = 10, page = 0, sort = []) => {
    const offset = page * limit;
    const notificationFilter = {
      filter: {
        type: "Notification",
        notificationType: {
          in: [type],
        },
        sort
      },
      limit: {
        limit,
        offset,
      },
    };

    return await notificationService
      .getNotificationByType(notificationFilter)
      .then((results) => {
        return results;
      });
  };

  @action
  downloadNotificationFile = (notificationTid, notificationType) => {
    notificationService.downloadNotificationFile(notificationTid, notificationType);
  };
}
